import axios, { axiosNL } from '../../../services/axios';
import { axiosNTL } from '../../../services/axios';

const fetchRePublishQueue = () => axiosNTL
	.get('/myLibraryQueue/republish/queue')
	.then((res: any) => {
		return Promise.resolve(res.responseObject);
	});

const removeRePublishQueueId = (id: string, type: any) => axiosNL
	.put(`myLibraryQueue/queue/${id}`,type)
	.then((res: any) => {
		return Promise.resolve(res.responseObject);
	});

const publishHoleQueue = () => axiosNL
	.post(`/myLibraryQueue/republish/queue`, {})
	.then((res: any) => {
		return Promise.resolve(res);
	});

const rePublishQueueService = {
	fetchRePublishQueue,
	removeRePublishQueueId,
	publishHoleQueue
};

export default rePublishQueueService;